import { render } from "./KeywordsModal.vue?vue&type=template&id=2df802f8&scoped=true"
import script from "./KeywordsModal.vue?vue&type=script&lang=js"
export * from "./KeywordsModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=2df802f8&scoped=true&lang=css"
import "./KeywordsModal.vue?vue&type=style&index=1&id=2df802f8&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df802f8"]])

export default __exports__